import { useQuery } from './query';
import { useState, useEffect } from 'react';

const SPECIAL_IATA_CODE_ALL_ELEMENTS = -1;
const ITEM_ALL_ELEMENTS = {
  label: 'cmp-filter-all-airlines-selected',
  iataCode: SPECIAL_IATA_CODE_ALL_ELEMENTS
};

function isSameData(array1, array2) {
  if (
    array1 === undefined ||
    array1 === null ||
    array2 === undefined ||
    array2 === null ||
    array1.length !== array2.length
  ) {
    return false;
  }
  for (let index = 0; index < array1.length; index++) {
    if (array1[index].iataCode !== array2[index].iataCode) {
      return false;
    }
  }
  return true;
}

function findIataCode(iataCode, airlinesSetBySetting) {
  if (airlinesSetBySetting) {
    for (let index = 0; index < airlinesSetBySetting.length; index++) {
      const airline = airlinesSetBySetting[index];
      if (airline.airlineCode === iataCode) {
        return { label: airline.labelKey, defaultValue: airline.defaultValue };
      }
    }
  }
  return '';
}

function getAvailableAirlines(airlinesSetBySetting, airlines) {
  let newOptions = [];
  for (let index = 0; index < airlines.length; index++) {
    const element = airlines[index];
    if (element.valid) {
      const { label, defaultValue } = findIataCode(element.iataCode, airlinesSetBySetting);
      if (label !== undefined && label !== '') {
        newOptions.push({
          iataCode: element.iataCode,
          label: label,
          defaultValue
        });
      }
    }
  }
  return newOptions;
}

function filterAirlines(airlinesSetBySetting, airlines) {
  if (airlines.length !== 0) {
    return getAvailableAirlines(airlinesSetBySetting, airlines);
  }
  return airlines;
}

export function useGetAirlines({
  dispatch,
  origin,
  destination,
  airlinesList,
  getAirlines,
  integrationSettings,
  prePopulation,
  meta,
  pageContext,
  isAvailableFilter,
  airlinesSetBySetting
}) {
  const isActive = origin.value !== '' && destination.value !== '' && isAvailableFilter;

  const getData = () => {
    let dataPromise;
    dataPromise = getAirlines(
      prePopulation.airlines,
      origin.value,
      destination.value,
      integrationSettings,
      meta,
      pageContext
    );
    return dataPromise
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };

  let tmp = useQuery({ getData, active: isActive }, [
    integrationSettings,
    origin,
    destination,
    prePopulation.airlineIataCode,
    prePopulation.airport,
    prePopulation.languageCode,
    meta,
    pageContext,
    airlinesList,
    getAirlines,
    isAvailableFilter
  ]);

  const newFilterAirlines = filterAirlines(airlinesSetBySetting, tmp.data);
  tmp.data = newFilterAirlines;

  return tmp;
}

export function useAirlines({
  dispatch,
  origin,
  destination,
  isAvailableFilter,
  getAirlines,
  integrationSettings,
  prePopulation,
  meta,
  pageContext,
  airlinesSetBySetting
}) {
  const [selectedAirlinesList, setSelectedAirlinesList] = useState(undefined);

  const airlines = useGetAirlines({
    dispatch,
    origin,
    destination,
    getAirlines,
    integrationSettings,
    prePopulation,
    meta,
    pageContext,
    isAvailableFilter,
    airlinesSetBySetting
  });

  if (!airlines.isLoading && airlines.data.length !== 0 && selectedAirlinesList === undefined) {
    const tmp =
      airlines.data.length > 1 ? [].concat([ITEM_ALL_ELEMENTS], airlines.data) : airlines.data;
    setSelectedAirlinesList(tmp);
    const payload = { value: airlines.data.map((e) => e.iataCode) };
    dispatch({
      type: 'AIRLINES_CHANGE',
      payload: payload
    });
  } else {
    if (
      (origin.value === undefined || destination.value === undefined) &&
      selectedAirlinesList !== undefined &&
      selectedAirlinesList !== null &&
      selectedAirlinesList.length !== 0
    ) {
      setSelectedAirlinesList(null);
    }
  }

  useEffect(() => {
    if (origin.value !== undefined && destination.value !== undefined) {
      setSelectedAirlinesList(undefined);
    }
  }, [origin.value, destination.value]);

  const filterItems = (items) => {
    let newItems = [];
    for (let index = 0; index < items.length; index++) {
      if (items[index].iataCode !== SPECIAL_IATA_CODE_ALL_ELEMENTS) {
        newItems.push(items[index].iataCode);
      }
    }
    return newItems;
  };

  const onChange = (items) => {
    setSelectedAirlinesList(items);
    if (!isSameData(selectedAirlinesList, items)) {
      let payload;
      if (isAvailableFilter) {
        payload = items === undefined ? { value: items } : { value: filterItems(items) };
        dispatch({
          type: 'AIRLINES_CHANGE',
          payload: payload
        });
      }
    }
  };

  const clear = () => {
    setSelectedAirlinesList(undefined);
  };

  return {
    disabled:
      origin.value === '' ||
      destination.value === '' ||
      origin.value === undefined ||
      destination.value === undefined,
    airlines: airlines,
    selectedAirlines: isAvailableFilter ? selectedAirlinesList : undefined,
    onChange,
    clear,
    isAvailableFilter
  };
}
